import State from "slotworks/state-machine/states/state";
import Components from "slotworks/components/components";
import changeMatrixCommand from "commands/change-matrix-command";

export class MultiReelSpin extends State {

    public onEnter() {
        changeMatrixCommand.trigger("multireel");

        Components.matrix.maskIndividualSymbols();
        this.skip();
    }
}
